// Gerencia o estado global persistido do Modo Identificar.
// Usado pelo toggle em CatalogoComponentes e pelo IdentificadorComponentes.
// Sem React — funciona em qualquer contexto (componente, lib, contexto).

const CHAVE_LS = 'fio:modo-identificar';
const EVENTO = 'fio:modo-identificar-change';

export function getModoIdentificar(): boolean {
  try {
    return localStorage.getItem(CHAVE_LS) === 'true';
  } catch {
    return false;
  }
}

export function setModoIdentificar(valor: boolean): void {
  try {
    if (valor) {
      localStorage.setItem(CHAVE_LS, 'true');
    } else {
      localStorage.removeItem(CHAVE_LS);
    }
    window.dispatchEvent(new CustomEvent(EVENTO, { detail: valor }));
  } catch {
    // silencioso se localStorage indisponivel
  }
}

/**
 * Escuta mudancas no modo identificar.
 * Retorna funcao de cleanup (removeEventListener).
 */
export function onModoIdentificarChange(cb: (ativo: boolean) => void): () => void {
  function handler(e: Event) {
    cb((e as CustomEvent<boolean>).detail);
  }
  window.addEventListener(EVENTO, handler);
  return () => window.removeEventListener(EVENTO, handler);
}
